/* app/js/src/components/calendar/loop-fill-shows-popup/loop-fill-shows-popup.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container {
  white-space: nowrap;
}
.container label {
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 20px;
}
.container evrideo-calendar-icon {
  cursor: pointer;
}
.container .pasteAfterButton {
  margin-left: 40px;
}
.container .controls {
  margin-top: 5px;
}
.container .controls #error-messsge {
  color: red;
  opacity: 1;
}
.container .controls #error-messsge .hidden {
  opacity: 0;
}
/*# sourceMappingURL=loop-fill-shows-popup.component.css.map */
